import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

// Public routes that don't require authentication
const PUBLIC_ROUTES = [
  '/',
  '/landing',
  '/flight-attendants',
  '/for-caterers',
  '/auth',
  '/auth/callback',
  '/join',
  '/admin/impersonate-callback',
  '/reset-password',
  '/onboarding',
  '/caterer/claim',
  '/caterer/invite-auth',
  '/caterer/set-password',
  '/terms-of-service',
  '/privacy-policy',
  '/return-policy',
  '/cookie-policy',
  '/pending-approval',
  '/banned',
  '/blog',
];

function isPublicAppRoute(pathname: string): boolean {
  if (PUBLIC_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`))) {
    return true;
  }
  if (pathname.startsWith('/CFA/search-caterers')) return true;
  if (pathname.startsWith('/CFA/caterers/')) return true;
  if (pathname.startsWith('/CFA/favourites/share/')) return true;
  if (pathname.startsWith('/share/favourites/')) return true;
  return false;
}

export const useAuthStateListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isPublicRoute = useRef(false);

  useEffect(() => {
    isPublicRoute.current = isPublicAppRoute(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT' && !isPublicRoute.current) {
        navigate('/auth/signin', { replace: true });
      }
      // TOKEN_REFRESHED and SIGNED_IN are handled by useUserRole
    });

    return () => subscription.unsubscribe();
  }, [navigate]);
};
